export const benchmarkResults = {
  state: {},
  reducers: {
    setRequestResult: (state, { guiltyDelay, innocentDelay, guiltyPercentage, operationName }) => ({
      ...state,
      [operationName]: { guiltyDelay, innocentDelay, guiltyPercentage },
    }),
  },
};
